import styled from 'styled-components'
import { Link as LinkRD } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'


export const Nav = styled.nav`
    background: #3ab0df;
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
    width: 100%;

    @media screen and (max-width: 960px)
    {
        transition: 0.8s all ease;
    }
`

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    /* max-width: 1100px; */
`

export const SocialIcon = styled.a`
    color: #fff;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 2.5rem;
    display: flex;
    align-items: center;
    margin-left: 22px;
    font-weight: bold;
    text-decoration: none;
`

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px)
    {
        color: #fff;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor:pointer;
    }
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;

    @media screen and (max-width: 960px)
    {
        display: none;
    }
`

export const NavItem = styled.li`
    height: 80px;
    font-size: 30px;
    padding: 45px;
`

export const NavLinks = styled(LinkS)`
    color: white;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    font-size: 2.1rem;

    /* &.active{
        border-bottom: 3px solid #fff;
    } */
`

export const Socials = styled.div `
    display: flex;
    text-align: center;
    cursor: pointer;

    &:hover {
        transition: all 0.2s ease-in-out;
        color: lightgray;
    }
`

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavBtnLink = styled(LinkRD)`
    border-radius: 50px;
    background: purple;
    white-space: nowrap;
    padding: 10px 22px;
    color: #fff;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: pink;
        color: white;
    }
`

export const Foot = styled.div`
    background: #3ab0df;
    height: 80px;
    margin-bottom: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: relative;
    bottom: 0;
    z-index: 10;
    width: 100%;
    color: #fff;
    @media screen and (max-width: 960px)
    {
        transition: 0.8s all ease;
    }
`

export const FootIcon = styled.a`
    color: #fff;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 2.5rem;
    display: flex;
    align-items: center;
    margin-left: 22px;
    margin-right: 22px;
    font-weight: bold;
    text-decoration: none;
`

export const CopyRight = styled.div`
    color: #fff;
    font-size: .9rem;
    display: flex;
    padding: 10px;
    justify-content: flex-start;
`